<template>
  <section v-if="queries.length" class="ai-visibility-question-fan-out-queries">
    <div class="ai-visibility-question-fan-out-queries__heading">
      <h3>Query fan-out</h3>
      <p>The smaller searches AI ran behind this one question</p>
      <p>
        AI doesn't search your question just once. It quietly splits it into several narrower searches, runs them in parallel, then stitches the best results into one answer. Each sub-query below is a separate spot you can show up in - win the ones where you're missing.
      </p>
    </div>

    <ul class="ai-visibility-question-fan-out-queries__list">
      <li
        v-for="query in paginatedQueries"
        :key="query"
        class="ai-visibility-question-fan-out-queries__row"
      >
        <i class="material-icons-round search-icon" aria-hidden="true">search</i>
        <span>{{ query }}</span>
      </li>
    </ul>
    <table-pagination
        v-if="pageCount > 1"
        :page="currentPage"
        :page-count="pageCount"
        @input="currentPage = $event"
    />
  </section>
</template>

<script>
import TablePagination from '../../../ui/table/TablePagination.vue'

const PAGE_SIZE = 15

export default {
  name: 'QuestionFanOutQueriesList',
  components: {
    TablePagination,
  },
  props: {
    queries: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      currentPage: 1,
    }
  },
  computed: {
    pageCount () {
      return Math.max(1, Math.ceil(this.queries.length / PAGE_SIZE))
    },
    paginatedQueries () {
      const startIndex = (this.currentPage - 1) * PAGE_SIZE
      return this.queries.slice(startIndex, startIndex + PAGE_SIZE)
    },
  },
  watch: {
    queries () {
      this.currentPage = 1
    },
    pageCount (pageCount) {
      if (this.currentPage > pageCount) {
        this.currentPage = pageCount
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-fan-out-queries {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ai-visibility-question-fan-out-queries__heading {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-visibility-question-fan-out-queries__heading h3,
.ai-visibility-question-fan-out-queries__heading p {
  margin: 0;
}

.ai-visibility-question-fan-out-queries__heading h3 {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 700;
}

.ai-visibility-question-fan-out-queries__heading p {
  color: var(--v-mainColor3-base);
  font-size: 14px;
  line-height: 1.45;
}

.ai-visibility-question-fan-out-queries__list {
  overflow: hidden;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 8px;
  background: var(--v-cardBg-base);
  list-style: none;
  margin: 0;
  padding: 0 16px;
}

.ai-visibility-question-fan-out-queries__row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  border-bottom: 1px dashed var(--v-gray12Color-base);
  padding: 12px 0;

  .search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    font-size: 13px;
    background-color: rgba(255, 87, 0, 0.1);
    color: var(--v-profileAnchorColor-base);
    border-radius: 6px;
  }

}

.ai-visibility-question-fan-out-queries__row:last-child {
  border-bottom: 0;
}

.ai-visibility-question-fan-out-queries__row i {
  flex: 0 0 auto;
  color: var(--v-mainColor-base);
  font-size: 18px;
  line-height: 1.25;
}

.ai-visibility-question-fan-out-queries__row span {
  min-width: 0;
  color: var(--v-mainColor-base);
  font-size: 14px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.ai-visibility-question-fan-out-queries ::v-deep .ai-visibility-table-pagination {
  padding: 10px 0 0;
}
</style>
